import {template as tpl, viewModel as MutableSystemPermission} from './mutable';
import {global} from "../../appContext";
import {ISystem} from "../../index";
import PromiseRequest from "../../req/PromiseRequest";
import {createErrorMessage} from "../../util/misc";
import {UPDATING_MESSAGE} from "../../constants/Language";
import {setRouteHash} from "../../constants/RouteDefinitions";

export let template = tpl;

export class viewModel extends MutableSystemPermission {

    protected reqSubmit = new PromiseRequest('updatesystem');

    protected override onGetSuccess(data: ISystem[]) {
        if (!data.find(s => s.id == global.getRouteId())) {
            this.messageData(createErrorMessage('no data'));
            return;
        }
        super.onGetSuccess(data);
    }

    protected onSubmit() {
        this.isReady(false);
        this.messageData({message: UPDATING_MESSAGE});
        const submitData = this.getSubmitData();
        const json = JSON.stringify(submitData);

        Promise.resolve()
        // update system access object
            .then(() => {
                return this.reqSubmit.request({jsystem: json});
            })
            // delete roles
            .then(() => {
                return Promise.all(this.getDeletedRoles().map(r => {
                    return new PromiseRequest('deleterole').request({id: r.id});
                }));
            })
            // update roles
            .then(() => {
                return Promise.all(this.getUpdatedRoles().map(r => {
                    return new PromiseRequest('updaterole').request({jrole: JSON.stringify(r)});
                }));
            })
            // create roles
            .then(() => {
                return Promise.all(this.getCreatedRoles().map(r => {
                    return new PromiseRequest('createrole').request({jrole: JSON.stringify(r)});
                }));
            })
            // cleanup
            .then(() => {
                global.cacheManager.removeCache('getruleset');
                global.cacheManager.removeCache('searchruleset');
                global.cacheManager.removeCache('searchsystem');
                global.snackbarData({message: `subject is updated|s:((collection))`});
                setRouteHash('systemaccessdetails', {id: this.d.id});
            })
            .catch(reason => {
                this.reqSubmit.abort();
                this.messageData(createErrorMessage(String(reason)));
                this.isReady(true);
            });
    }

    protected override getSubmitData(): ISystem {
        const d = super.getSubmitData();
        d.id = this.d.id;
        return d;
    }


}
